import { Badge } from './badge';
import { cn } from '../lib/cn';

type Severity = 'standard' | 'recommended' | 'optional';

const styles: Record<Severity, string> = {
  standard: 'border-transparent bg-rose-500/20 text-rose-200',
  recommended: 'border-transparent bg-amber-500/20 text-amber-200',
  optional: 'border-transparent bg-neutral-500/20 text-neutral-300',
};

export function KbSeverityBadge({ severity, className }: { severity: Severity; className?: string }) {
  return <Badge className={cn(styles[severity], className)}>{severity}</Badge>;
}
